import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { Fader } from "@formant/ui/component/common/Fader";

import { ISnackbarState } from "../store/IAppStore";
import { appStore } from "../stores";
import { Escape } from "./common/Escape";
import { HandleKey } from "./common/HandleKey";
import { TextButton } from "./common/TextButton";
import * as styles from "./Snackbar.scss";

@observer
export class Snackbar extends Component {
    private snackbar: ISnackbarState | undefined;
    public render() {
        this.snackbar = appStore.snackbar || this.snackbar;
        const snackbar = this.snackbar;

        const position = snackbar?.position || "side";
        const visible = !!appStore.snackbar;
        return (
            <Fader
                className={classnames(styles.snackbar, styles[position])}
                visible={visible}
            >
                <div className={styles.message}>{snackbar?.message}</div>
                {snackbar?.actions && <Escape onEsc={this.onEsc} />}
                {snackbar?.actions &&
                    snackbar?.actions.map(
                        ({ label, onClick, actionKey }, i) => (
                            <div key={`snackbar-${i}`}>
                                {actionKey && (
                                    <HandleKey
                                        keyName={actionKey}
                                        onPress={onClick}
                                    />
                                )}
                                <TextButton
                                    key={`snackbar-${i}`}
                                    onClick={onClick}
                                    className={styles.action}
                                    data-testid={`snackbar-${label}`}
                                >
                                    {label}
                                </TextButton>
                            </div>
                        ),
                    )}
                {snackbar?.action && (
                    <TextButton
                        onClick={snackbar?.action.onClick}
                        className={styles.action}
                        data-testid={`snackbar-${snackbar?.action.label}`}
                    >
                        <Escape onEsc={this.onEsc} />
                        {snackbar?.action.label}
                    </TextButton>
                )}
            </Fader>
        );
    }

    private onEsc = () => {
        appStore.clearSnackbar();
    };
}
